import Component from "../../component";

export default class ImageSlider extends Component{

    ready() {
        $('.slick-slider').slick({
            dots: true,
            infinite: true,
            arrows:false,
            speed: 500,
            cssEase: 'linear'
        });
    }
}